module.exports = __webpack_public_path__ + "img/banner-1.50b12dfa.jpg";